import React from 'react'

const NotResultsText = ({ children }) => {
  return <p className="not-results-text">{children}</p>
}

export default NotResultsText
